(function HotelEngineRates($, Adzuki)
{
    'use strict';

    const component = {
        emits : ['component-event'],
        inject: {
            $inject_loggedIn: {
                default: false
            },
            setLoggedIn: {
                default: () => undefined
            }
        },
        props: {
            rates: {
                type    : Array,
                required: false,
                default : () => []
            },
            criteria: {
                type    : Object,
                required: true,
            },
            showPayLater: {
                type   : Boolean,
                default: false
            }
        },
        template: `
          <div class="hotel-details-room-card-inner">
            <div class="hotel-details-rate-body">
              <template v-if="rateList.length">
                <h4>{{rateList.length}} Additional Rates Found</h4>
                <table class="table table-striped margin10-top hotel-details-rates-table">
                  <thead>
                    <tr>
                      <th class="text-center">Refundable</th>
                      <th v-if="showPayLater" class="text-center">Eligible to Pay Later</th>
                      <th class="text-center">Included</th>
                      <th class="text-center">Per Night</th>
                      <th class="text-center">Total Price</th>
                      <th class="text-center">Rooms Available</th>
                      <th class="text-center">More Information</th>
                      <th class="text-center"></th>
                    </tr>
                  </thead>
                  <tbody class="hotel-engine-room-rates">
                    <template
                        v-for="(rate, rateIdx) in rateList"
                        :key="rateIdx"
                    >
                    <tr
                        class="hotel-details-rate-block"
                        :class="{ 'hotel-details-rate-block--expanded': expandedRateIndex === rateIdx }"
                    >
                      <td class="text-center hotel-details-rate-cell">
                        <div class="hotel-details-rate-row">
                          <div class="hotel-details-rate-value">
                            <template v-if="rate.refundable || rate.pricing?.refundable">
                              <i class="fa fa-check text-success" aria-hidden="true"></i>
                              <template v-if="rate.cancellation_policies && rate.cancellation_policies[0] && rate.cancellation_policies[0].end_date">
                                Free cancellation before <span v-format-date="rate.cancellation_policies[0].end_date"></span>
                              </template>
                              <template v-else>
                                Refundable
                              </template>
                            </template>
                            <span v-else class="text-danger">
                              <i class="fa fa-warning text-danger" aria-hidden="true"></i> Non-refundable
                            </span>
                          </div>
                        </div>
                      </td>
                      <td v-if="showPayLater" class="text-center hotel-details-rate-cell">
                        <div class="hotel-details-rate-row">
                          <div class="hotel-details-rate-value">
                            <span v-if="rate.pay_later_eligible">
                              Eligible for Pay Later
                            </span>
                            <span v-else>
                              Not eligible for Pay Later
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="text-center hotel-details-rate-cell">
                        <div class="hotel-details-rate-row">
                          <div class="hotel-details-rate-value">{{ formatBoardInfo(rate) }}</div>
                        </div>
                      </td>
                      <td class="text-center hotel-details-rate-cell">
                        <div class="hotel-details-rate-row">
                          <div
                              class="hotel-details-rate-value"
                              v-format-currency="roomPrices[rateIdx].per_night_per_room"
                          >
                          </div>
                        </div>
                      </td>
                      <td class="text-center hotel-details-rate-cell">
                        <div class="hotel-details-rate-row">
                          <div class="hotel-details-rate-value hotel-details-rate-total">
                            <span v-format-currency="roomPrices[rateIdx].totalCost"></span>
                            <span class="hotel-details-rate-disclaimer">Includes taxes and fees</span>
                          </div>
                        </div>
                      </td>
                      <td class="text-center hotel-details-rate-cell">
                        <div class="hotel-details-rate-row">
                          <div class="hotel-details-rate-value">
                            {{ rate.available_rooms != null ? rate.available_rooms + ' or more' : '1 or more' }}
                          </div>
                        </div>
                      </td>
                      <td class="text-center hotel-details-rate-cell">
                        <div class="hotel-details-rate-row">
                          <div class="hotel-details-rate-value">
                            <a href="#"
                               class="hotel-details-view-details"
                               :class="{ 'hotel-details-view-details--active': expandedRateIndex === rateIdx }"
                               @click.prevent="toggleRateDetails(rateIdx)">
                              <i class="fa fa-info-circle" aria-hidden="true"></i>
                              {{ expandedRateIndex === rateIdx ? 'Hide Details' : 'View Details' }}
                            </a>
                          </div>
                        </div>
                      </td>
                      <td class="text-center hotel-details-rate-cell hotel-details-room-actions">
                        <div class="hotel-details-rate-row">
                          <div class="hotel-details-rate-value">
                            <adzuki-loading
                                v-if="loadingRateIndex === rateIdx"
                                :loader-type="'button'"
                                :button-class="'hotel-details-select-rate-btn hotel-book-now-btn'"
                            ></adzuki-loading>
                            <button
                                v-if="loadingRateIndex !== rateIdx"
                                type="button"
                                class="hotel-details-select-rate-btn hotel-book-now-btn"
                                @click="chooseRoom(rateIdx, rate.rate_select_string)"
                            >
                              Select Rate
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr class="hotel-details-rate-accordion-row">
                      <td :colspan="rateTableColspan">
                        <div
                            class="hotel-details-rate-accordion-wrap"
                            :class="{ 'hotel-details-rate-accordion-wrap--open': expandedRateIndex === rateIdx }"
                        >
                          <div class="hotel-details-rate-accordion-inner">
                            <div class="hotel-details-rate-accordion-content">
                              <he-room-modal-content :rate="rate"></he-room-modal-content>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </template>
                  </tbody>
                </table>
              </template>
            </div>
          </div>
        `,
        data() {
            return {
                baseUri          : Adzuki.base_uri,
                showModal        : false,
                componentToRender: null,
                modalTitle       : '',
                modalProps       : {},
                loadingRateIndex : null,
                expandedRateIndex: null,
            };
        },
        computed: {
            numNights() {
                const checkInDate  = new Date(this.criteria.check_in);
                const checkOutDate = new Date(this.criteria.check_out);

                // Ensure check-in date is earlier than check-out date
                if (checkOutDate <= checkInDate) {
                    return 0; // No nights if checkout is the same or earlier than check-in
                }

                // Calculate the difference in time (milliseconds)
                const timeDifference = checkOutDate - checkInDate;

                // Convert the time difference to days (1 day = 24 * 60 * 60 * 1000 ms)
                return timeDifference / (1000 * 60 * 60 * 24);

            },
            // Rates arrive as an array, an object keyed by rate id, or null when a room has none.
            rateList() {
                if (Array.isArray(this.rates)) {
                    return this.rates.filter(Boolean);
                }

                if (this.rates && typeof this.rates === 'object') {
                    return Object.values(this.rates).filter(Boolean);
                }

                return [];
            },
            roomPrices() {
                return Adzuki.HotelEngine.computeRatesPrices(this.rateList, {
                    numNights: this.numNights || 1,
                    numRooms : this.criteria?.rooms?.length || 1,
                });
            },
            rateTableColspan() {
                return this.showPayLater ? 8 : 7;
            },
        },
        methods: {
            formatBoardInfo(rate) {
                const boardInfo = rate?.provider_data?.board_info;

                if (boardInfo && typeof boardInfo !== 'object') {
                    return String(boardInfo) || '—';
                }

                const items = (Array.isArray(boardInfo) ? boardInfo : Object.values(boardInfo || {}))
                    .map((item) => String(item ?? '').trim())
                    .filter(Boolean);

                return items.length ? items.slice(0, 3).join(', ') : '—';
            },
            toggleRateDetails(rateIndex) {
                this.expandedRateIndex = this.expandedRateIndex === rateIndex ? null : rateIndex;
            },
            chooseRoom(rateIndex, rate_select_string) {
               this.loadingRateIndex = rateIndex;
                this.$emit('component-event', {
                    type: 'book-room',
                    rate_select_string
                });
            }
        },
    };

    Adzuki.VueComponents.HotelEngineRates = component;
}(jQuery, window.Adzuki || {}));
